import { useQuery } from '@tanstack/react-query';
import { permissionDemoApi } from '../api/permissionDemoApi';
import type { RolePermissionMatrixResponse, ApiError } from '../types/permissionDemo';

/**
 * Query: GET /api/eraf/permission-demo/matrix
 * Lazy — only fires when the matrix tab is active (enabled prop).
 * Backed by DynamicPermissionService.gatewayCatalog() (cached server-side).
 * p95 target < 200ms.
 */
export function useMatrix(enabled: boolean) {
  return useQuery<RolePermissionMatrixResponse, ApiError>({
    queryKey: ['permission-demo', 'matrix'],
    queryFn: () => permissionDemoApi.getMatrix(),
    enabled,
    retry: false,
    staleTime: 120_000,
  });
}
